import { ModeType } from 'src/app/enums/mode-type.enum';
import { RegionType } from 'src/app/enums/region-type.enum';

export const environment = {
  configurationData: [],
  mode: ModeType.Aramark_Staging,
  production: false,
  US: {
    userPoolId: 'us-east-1_k8qFPPquE',
    region: RegionType.USA,
    regionName: 'United States of America',
    clientId: '4rdkgt9887evud6mimqvcg0mpu',
    appClients: [
      {
        id: 'NHJka2d0OTg4N2V2dWQ2bWltcXZjZzBtcHU=',
        urlOmni: 'https://identity.api.pat.cbord.com',
        urlTLMiddleware: 'https://stg.api.aramark.traylogistics.cbord.com',
      },
    ],
  },
  accessKeyId: '',
  secretAccessKey: '',
  parameterSSM: '',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
